import FAQSection from '../../../common/FAQSection/FAQSection';

import texts from './FAQs.texts.json';

import styles from './FAQs.scss';

export const FAQs = ({ belowReserve }: { belowReserve: boolean }) => <FAQSection
  className={styles.faqs}
  faq={belowReserve ? texts.belowReserve.faqs : texts.aboveReserve.faqs}
  size="full"
  title="FAQs"
/>;
